export const PERMISOS_CONFIG = [
  { key: 'inicio', nombre: 'Inicio' },
  { key: 'banners', nombre: 'Banners' },
  { key: 'clientes', nombre: 'Clientes' },
  { key: 'cotizaciones', nombre: 'Cotizaciones' },
  { key: 'usuarios', nombre: 'Usuarios' },
  { key: 'departamentos', nombre: 'Departamentos' },
  { key: 'subdepartamentos', nombre: 'Subdepartamentos' },
  { key: 'marcas', nombre: 'Marcas' },
  { key: 'niveles', nombre: 'Niveles' },
  { key: 'unidades', nombre: 'Unidades' },
  { key: 'productos', nombre: 'Productos' },
  { key: 'dashboard', nombre: 'Dashboard' },
  { key: 'sucursales', nombre: 'Sucursales' }
]

const PERMISOS_KEYS = PERMISOS_CONFIG.map(({ key }) => key)
const LIMITADO_KEYS = ['productos', 'banners', 'departamentos', 'subdepartamentos', 'marcas']

export const buildPermisosMap = (enabledKeys = []) => {
  const allowed = new Set((enabledKeys || []).map(key => String(key).toLowerCase()))
  const map = {}
  PERMISOS_KEYS.forEach(key => {
    map[key] = allowed.has(key.toLowerCase())
  })
  return map
}

const ADMIN_TEMPLATE = buildPermisosMap(PERMISOS_KEYS)
const LIMITADO_TEMPLATE = buildPermisosMap(LIMITADO_KEYS)

export const getDefaultPermisosByTipo = (tipo = 'Limitado') => {
  const normalized = String(tipo || '').trim().toLowerCase()
  if (normalized === 'administrador' || normalized === 'superadministrador') {
    return { ...ADMIN_TEMPLATE }
  }
  return { ...LIMITADO_TEMPLATE }
}

export const getAllPermisosKeys = () => [...PERMISOS_KEYS]
export const getLimitadoPermisosKeys = () => [...LIMITADO_KEYS]
